import * as Yup from "yup";

export const formValidationSchema = () =>
  Yup.object().shape({
    tglPostingStockOpname: Yup.string().required("Pilih tanggal").nullable(),
    nomorAkunDebet: Yup.string().required("Pilih COA debet").nullable(),
    nomorAkunKredit: Yup.string().required("Pilih COA kredit").nullable(),
    keteranganJurnal: Yup.string().required("Masukan keterangan").nullable(),
  });
